/**
 * Store hours gate.
 *
 * Single source of truth for "are we accepting orders right now".
 * Blocks every checkout path in the theme, not just the order-menu side cart.
 *
 * EDIT THE HOURS HERE — nowhere else.
 */
(function () {
  'use strict';

  // Orders are accepted from the day's opening time until CLOSE_AT
  // (local Sofia time). Sundays open later.
  var CLOSE_AT = { hour: 21, minute: 30 }; // last orders accepted up to 21:29
  var OPEN_AT = { hour: 11, minute: 0 };
  var SUNDAY_OPEN_AT = { hour: 12, minute: 0 };
  var TIMEZONE = 'Europe/Sofia';
  var MESSAGE_PREFIX = 'Поръчките са затворени, защото не работим. ';
  var OPENS_MESSAGE = 'Отваряме 11 сутрин.';
  var SUNDAY_OPENS_MESSAGE = 'В неделя отваряме в 12 часа.';
  var CLOSED_MESSAGE = MESSAGE_PREFIX + OPENS_MESSAGE;

  var CLOSED_START_MIN = CLOSE_AT.hour * 60 + CLOSE_AT.minute;
  var CLOSED_END_MIN = OPEN_AT.hour * 60 + OPEN_AT.minute;
  var SUNDAY_CLOSED_END_MIN = SUNDAY_OPEN_AT.hour * 60 + SUNDAY_OPEN_AT.minute;

  var formatter = null;
  try {
    formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: TIMEZONE,
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  } catch (e) {
    formatter = null;
  }

  /**
   * Current time in the shop's timezone as { mins, day }, where mins is
   * minutes since midnight and day is 'Mon'…'Sun'. Returns null if unavailable.
   */
  function shopNow() {
    if (!formatter) return null;
    try {
      var parts = formatter.formatToParts(new Date());
      var get = function (type) {
        return (parts.find(function (p) { return p.type === type; }) || {}).value;
      };
      // Some engines format midnight as "24".
      var h = Number(get('hour') || 0) % 24;
      var m = Number(get('minute') || 0);
      return { mins: h * 60 + m, day: get('weekday') };
    } catch (e) {
      return null;
    }
  }

  function opensAtFor(day) {
    return day === 'Sun' ? SUNDAY_CLOSED_END_MIN : CLOSED_END_MIN;
  }

  /**
   * Evaluated fresh on every call — never cache the result.
   * Fails open (returns false) if the timezone can't be read, so a broken
   * browser can still order rather than being locked out all day.
   */
  function isClosed() {
    var now = shopNow();
    if (!now) return false;
    return now.mins >= CLOSED_START_MIN || now.mins < opensAtFor(now.day);
  }

  /** Closed message naming the next opening time (Sunday opens later). */
  function closedMessage() {
    var now = shopNow();
    if (!now) return CLOSED_MESSAGE;
    // After closing the next opening is tomorrow (Saturday night -> Sunday);
    // before opening it's today.
    var nextIsSunday = now.mins >= CLOSED_START_MIN ? now.day === 'Sat' : now.day === 'Sun';
    return MESSAGE_PREFIX + (nextIsSunday ? SUNDAY_OPENS_MESSAGE : OPENS_MESSAGE);
  }

  var StoreHours = {
    isClosed: isClosed,
    closedMessage: closedMessage,
    message: CLOSED_MESSAGE,
    closesAt: CLOSED_START_MIN,
    opensAt: CLOSED_END_MIN,
    sundayOpensAt: SUNDAY_CLOSED_END_MIN,
  };
  window.StoreHours = StoreHours;

  // --- Reflect state in the DOM so CSS can hide/disable things -------------

  function paint() {
    var closed = isClosed();
    StoreHours.message = closedMessage();
    document.documentElement.classList.toggle('store-closed', closed);
    document.documentElement.classList.toggle('store-open', !closed);

    // Native checkout buttons (cart page + cart drawer).
    var buttons = document.querySelectorAll(
      'button[name="checkout"], #checkout, [data-checkout-trigger]'
    );
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      // Not `disabled`: a disabled button swallows the click, so the
      // closed popup below would never show.
      if (closed) {
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('data-store-hours-closed', '');
        addNotice(btn);
      } else if (btn.hasAttribute('data-store-hours-closed')) {
        // Only touch buttons we marked — leave the theme's own
        // empty-cart disabling alone.
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('data-store-hours-closed');
        removeNotice(btn);
      }
    }
    return closed;
  }

  function addNotice(btn) {
    var parent = btn.parentElement;
    if (!parent) return;
    var existing = parent.querySelector('.store-closed-notice');
    if (existing) {
      existing.textContent = StoreHours.message;
      return;
    }
    // The order-menu side cart renders its own message already.
    if (parent.querySelector('[data-closed-msg]')) return;
    var el = document.createElement('div');
    el.className = 'store-closed-notice';
    el.setAttribute('role', 'status');
    el.textContent = StoreHours.message;
    parent.insertBefore(el, btn);
  }

  function removeNotice(btn) {
    var parent = btn.parentElement;
    if (!parent) return;
    var el = parent.querySelector('.store-closed-notice');
    if (el) el.remove();
  }

  // --- Closed popup -------------------------------------------------------
  // Our own dialog rather than window.alert(), whose title and button are in
  // the browser's language instead of Bulgarian.

  var popup = null;

  function showClosedPopup() {
    if (!popup) {
      popup = document.createElement('div');
      popup.className = 'store-closed-popup';
      popup.setAttribute('role', 'alertdialog');
      popup.setAttribute('aria-modal', 'true');
      popup.setAttribute('aria-labelledby', 'store-closed-popup-title');
      popup.setAttribute('aria-describedby', 'store-closed-popup-text');
      popup.innerHTML =
        '<div class="store-closed-popup__dialog">' +
        '<h4 class="store-closed-popup__title" id="store-closed-popup-title">Затворено</h4>' +
        '<p class="store-closed-popup__text" id="store-closed-popup-text"></p>' +
        '<button type="button" class="store-closed-popup__ok">Разбрах</button>' +
        '</div>';
      popup.addEventListener('click', function (event) {
        if (event.target === popup || event.target.closest('.store-closed-popup__ok')) {
          hideClosedPopup();
        }
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && popup.classList.contains('is-open')) hideClosedPopup();
      });
      document.body.appendChild(popup);
    }
    popup.querySelector('.store-closed-popup__text').textContent = closedMessage();
    popup.classList.add('is-open');
    popup.querySelector('.store-closed-popup__ok').focus();
  }

  function hideClosedPopup() {
    if (popup) popup.classList.remove('is-open');
  }

  StoreHours.showClosedPopup = showClosedPopup;

  // --- Hard block on every checkout path ----------------------------------

  function block(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    paint();
    showClosedPopup();
  }

  // Capture phase, so this runs before any theme or app handler.
  document.addEventListener(
    'click',
    function (event) {
      if (!isClosed()) return;
      var target = event.target;
      if (!target || !target.closest) return;
      var hit = target.closest(
        'button[name="checkout"], #checkout, [data-checkout-trigger], [data-note-submit], a[href*="/checkout"]'
      );
      if (hit) block(event);
    },
    true
  );

  // Cart forms submitted by other means (Enter key, app scripts).
  document.addEventListener(
    'submit',
    function (event) {
      if (!isClosed()) return;
      var form = event.target;
      if (!form || !form.action) return;
      if (/\/(checkout|cart)\b/.test(String(form.action))) block(event);
    },
    true
  );

  // --- Keep it live -------------------------------------------------------

  paint();
  document.addEventListener('DOMContentLoaded', paint);
  setInterval(paint, 30 * 1000);
  // A page restored from bfcache or refocused after hours must re-evaluate.
  window.addEventListener('pageshow', paint);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) paint();
  });
})();
